export { StudentProfilePromptModal } from "./StudentProfilePromptModal"
export type { StudentProfilePromptModalProps, UIStudentProfilePromptStep } from "./StudentProfilePromptModal"
